import React, { useEffect, useState } from "react"
import "plyr/dist/plyr.css"
import { deviceType } from "detect-it"
import loadable from "@loadable/component";

// import CloudinaryVideo from "./cloudinaryvideo"
const CloudinaryVideo = loadable(() => import("../components/cloudinaryvideo"), {
  ssr: false, // Disables Server-Side Rendering
});

// class VimeoPlyrEmbed extends Component {
const VimeoPlyrEmbed = ({
  source,
  label,
  title,
  textAlign,
  autoPlay = false,
  posterGif = false,
  posterGifSource = "",
  onChange = {},
  posterImg = false,
  hero = false,
  reverseLabelOrder = false,
}) => {
  const [isPlaying, setIsPlaying] = useState(false)
  const [playerEl, setPlayerEl] = useState()
  const [videoStarted, setVideoStarted] = useState(false) // only used to hide "gif" overlay when resuming video

  useEffect(() => {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      let options = {
        hideControls: true,
        autoplay: autoPlay,
        volume: 3,
        controls: [],
        fullscreen: { enabled: true, iosNative: true, fallback: true },
      }

      if (deviceType != "mouseOnly") {
        options["hideControls"] = false
        options["controls"] = ["play-large", "fullscreen"]
      }

      if (source) {
        const Plyr = require("plyr")
        let plyr = new Plyr(".js-plyr", options)

        plyr.on("ready", () => {
          setPlayerEl(plyr)
        })
        plyr.on("play", () => {
          // document.getElementById('mouse-circle').classList.toggle('pause')
          // document.querySelector('.cursor').classList.toggle('cursor--video-hover-playing')
          setIsPlaying(true)
          if (hero) {
            onChange()
          }
        })
      }

      if (playerEl) {
        // playerEl.toggleControls(false)
        if (isPlaying) {
          if (!playerEl.playing) {
            playerEl.play()
            setVideoStarted(true)

            if (hero) {
              // if(posterGif || hero) {
              onChange()
            }
          }
          // playerEl.toggleControls(true)
        } else {
          playerEl.pause()
          // playerEl.toggleControls(false)
        }
      }
    }
  }, [isPlaying, playerEl, autoPlay])

  return (
    <div
      className={`bg-black relative aspect-ratio-16/9${
        hero ? " video-hover" : ""
      }${hero && isPlaying ? " video-hover--playing" : ""}`}
    >
      {deviceType === "mouseOnly" && !hero && source ? (
        <div
          onClick={() => {
            setIsPlaying(!isPlaying)
          }}
          className={`absolute top-0 left-0 w-full h-full z-10 ${
            source ? " video-hover" : ""
          }${isPlaying ? " video-hover--playing" : ""}`}
        ></div>
      ) : (
        ""
      )}

      {source ? (
        <div className="absolute w-full h-full top-0 left-0">
          <video
            className="js-plyr plyr"
            poster={posterImg ? posterImg : undefined}
            playsInline
            autoPlay={autoPlay}
            allowFullScreen
          >
            <source src={source} type="video/mp4" />
          </video>
        </div>
      ) : (
        ""
      )}

      
        <div
          className={`bg-black text-white bg-opacity-50 pointer-events-none absolute top-0 left-0 w-full h-full transition${
            !posterGif ? " p-10" : ""
          }${isPlaying ? " opacity-0" : ""}`}
        >
          {posterGif && posterGifSource && !videoStarted ? (
            <CloudinaryVideo
              class_list="w-full h-full object-cover"
              publicUrl={posterGifSource}
              autoPlay={true}
            />
          ) : (
            ""
          )}
          {title ? (
            <h1
              itemProp="headline"
              className={`text-mobmd med:text-md lrg:text-${
                textAlign == "text-center" ? "xl " : "lg "
              }absolute block w-full px-10 left-0 top-1/2 transform -translate-y-1/2 pb-44 ${textAlign}`}
            >
              {label && !reverseLabelOrder ? (
                <>
                  <span className="text-sm med:text-base block mb-2 lrg:mb-6">
                    {label}
                  </span>
                </>
              ) : (
                ""
              )}
              {title}
              {label && reverseLabelOrder ? (
                <>
                  <span className="text-sm med:text-base block mt-2 lrg:mt-6">
                    {label}
                  </span>
                </>
              ) : (
                ""
              )}
            </h1>
          ) : (
            ""
          )}
        </div>
    </div>
  )
}

export default VimeoPlyrEmbed
